<template>
  <b-col cols="12" sm="12">
    <div>
      <a class="btnVolver" @click="$router.push({ path: 'dispositivos' })" title="Cerrar">
        <feather id="btnX" type="arrow-left-circle"></feather>
      </a>
    </div>
    <b-card class="mx-auto" tile>
      <div class="row d-flex justify-content-center">
        <div class="col-12">
          <b-form @submit.stop.prevent="updateDispositivo" style="z-index: 1">
            <b-col cols="12" sm="12">
              <h4 v-html="$t('vDispositivos.msgTxtDispoLink',
                { 0: '<b>' + dispositivo.nombre + '</b>', })">
              </h4>
              <div class="row">
                <div class="col-12">
                  <h5 class="mb-0 mt-2">
                    {{ this.$t("vDispositivos.msgTxtTiempoLink") }}:
                  </h5>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 div-display-block">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                      <b-form-select :options="translateTiempo" required v-model="selected" @input="tiempoSelected">
                        <template #first>
                          <b-form-select-option :value="null" disabled>{{ $t("configDispositivos.medidaTiempo") }}
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                      <b-form-input type="number" id="intervalos" v-model="dispositivo.compartirHasta" required
                        :state="tiempoState" min="1" max="maximo" value="0">
                      </b-form-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <b-col cols="12" lg="12" xl="12" md="12" sm="12">
                  <b-form-textarea class="form-textarea" id="linkGenerado" v-model="linkGenerado"
                    :placeholder="this.$t('vDispositivos.msgTxtLinkGenerado')" disabled rows="6" max-rows="6">
                  </b-form-textarea>
                </b-col>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-4 d-lg-flex justify-content-lg-end">
                  <b-btn color="primary" class="w-100 ancho-boton" style="color: white" to="/Dispositivos">
                    {{ $t("Gral.cancelar") }}
                  </b-btn>
                </div>
                <div class="col-12 col-sm-12 col-md-4 d-lg-flex justify-content-lg-center div-separacion">
                  <b-btn variant="info" class="w-100 ancho-boton" style="color: white" type="submit"
                    :disabled="validaciones()">
                    {{ $t("vDispositivos.generarLink") }}
                  </b-btn>
                </div>
                <div class="col-12 col-sm-12 col-md-4 div-separacion">
                  <b-btn variant="info" class="w-100 ancho-boton" style="color: white" type="button"
                    v-clipboard:copy="linkGenerado" v-clipboard:success="onCopy" v-clipboard:error="onError"
                    :disabled="habilitarCopiar()">
                    {{ $t("vDispositivos.copiarLink") }}
                  </b-btn>
                </div>
              </div>
            </b-col>
          </b-form>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script src="js/main.js"></script>
<script>
import { mapState } from "vuex";
import token from "@/controllers/dispositivoTokenController";
import DevicesDataService from "@/services/DevicesDataService";
import AreaDataService from "@/services/AreaDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from '../../../services/Crypto';
import { verificarAcceso } from '../../../utils/Session';

export default {
  name: "share_link",
  data() {
    return {
      filtro: "",
      unidad: "milisegundos",
      tiempoMilisegundos: 0,
      seGeneroLink: false,
      linkGenerado: "",
      compartirHastaActual: 0,
      minimo: 0,
      maximo: 0,
      dispositivo: {
        id: 0,
        nombre: "",
        contrasena: "",
        imei: "",
        modelo: "",
        model: null,
        telefono: "",
        usuarios: [],
        usuariosCadena: [],
        area: null,
        compartirLink: false,
        compartirHasta: 0,
      },
      selected: null,
      tiempo: [
        {
          text: "diasM",
          value: "d",
        },
        {
          text: "horasM",
          value: "h",
        },
        {
          text: "minutosM",
          value: "m",
        },
      ],
      usuariosGrupo: [],
      submitted: false,
      areas: this.obtenerAreas(),
      master: false,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: ""
    };
  },
  beforeCreate() {
    verificarAcceso();

    if (
      !sessionStorage.getItem("rol") ||
      sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL
    ) {
      this.$router.push({
        path: "/monitoreo",
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: this.$t("vDispositivos.noPermisos"),
      });
    }
  },
  mounted() {
    this.key = sessionStorage.getItem('key')
    this.mostrarDispositivo(this.$route.params);
    this.$nextTick(() => {});
  },
  computed: {
    ...mapState(["locale"]),
    translateTiempo() {
      return this.translateOptions(this.tiempo);
    },
    tiempoState() {
      if (this.dispositivo.compartirHasta > 0) {
        return this.dispositivo.compartirHasta <= this.maximo ? true : false;
      }
      return false;
    },
  },
  methods: {
    translateOptions(values) {
      return values.map((option) => {
        if (typeof option === "object" && option.text) {
          return {
            ...option,
            text: this.$t(`configDispositivos.${option.text}`),
          };
        }
      });
    },
    mostrarDispositivo(datos) {
      if (datos.imei == null) {
        this.$router.push({
          path: "/dispositivos",
        });
      }
      this.dispositivo.id = datos.id;
      this.dispositivo.nombre = datos.nombre;
      this.dispositivo.contrasena = datos.contrasena;
      this.dispositivo.imei = datos.imei;
      this.dispositivo.telefono = datos.telefono;
      this.dispositivo.usuarios = datos.usuarios;
      this.dispositivo.modelo = datos.modelo;
      this.dispositivo.model = datos.modeloGps;
      this.dispositivo.compartirLink = datos.compartirLink;
      this.compartirHastaActual = datos.compartirHasta;
      if (datos.area == null) {
        this.dispositivo.area = null;
      } else {
        this.dispositivo.area = datos.area == null ? "NULL" : datos.area.id;
      }
    },
    updateDispositivo() {
      var data = {
        id: this.dispositivo.id,
        nombre: this.dispositivo.nombre,
        contrasena: this.dispositivo.contrasena,
        modelo: this.dispositivo.modelo,
        model: this.dispositivo.model,
        telefono: this.dispositivo.telefono,
        imei: this.dispositivo.imei,
        usuarios: this.dispositivo.usuarios,
        area: this.areas.find((item) => item.id === this.dispositivo.area),
        compartirLink: true,
        compartirHasta: this.convertirTiempoMilisegundos(),
      };
      let txt = "IMEI"; //Texto para concatenar con el dato IMEI/Id
      switch (data.modelo) {
        case "TKSTAR":
          txt = "Id";
          break;

        case "TK108":
        case "GPSAU":
          txt = "IMEI";
          break;
      }
      DevicesDataService.update(data, this.key)
        .then(() => {
          this.accion =
            "Generó un link para el dispositivo " +
            data.nombre +
            " con " +
            txt +
            " " +
            data.imei +
            " por " +
            this.dispositivo.compartirHasta +
            " " +
            this.unidad;
          this.registrarAccion();
          this.generarLink();
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: this.$t("vDispositivos.msgLinkGenerado"),
          });
        })
        .catch((e) => {
          var titulo;
          if (e.response.status !== 400) {
            titulo = this.$t("vDispositivos.msgErrGenerarLink");
          }
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: titulo,
          });
        });
    },
    convertirTiempoMilisegundos() {
      switch (this.unidad) {
        case "días":
          this.tiempoMilisegundos = 86400000 * this.dispositivo.compartirHasta;
          break;
        case "horas":
          this.tiempoMilisegundos = 3600000 * this.dispositivo.compartirHasta;
          break;
        case "minutos":
          this.tiempoMilisegundos = 60000 * this.dispositivo.compartirHasta;
          break;
      }
      return this.tiempoMilisegundos;
    },
    async generarLink() {
      //AQUI SE GENERA EL TOKEN DE AUTENTICACION Y SE INCORPORA AL LINK DE ACCESO
      //UNA VEZ GENERADO EL LINK, LA RESPUESTA DEBE SER VISIBLE EN LA CAJA DE LINK GENERADO
      const datos = {
        username: this.dispositivo.nombre,
        password: this.dispositivo.id,
        servidor: localStorage.getItem("servidor"),
      };
      
      token.generar(datos, this.key).then(async(response) => {
        
        //Si nos devuelve un token de acceso, se genera el link
        const decoded = await Crypto.desencriptar(response.data, this.key);

        this.linkGenerado = `${process.env.VUE_APP_URL_LINK}/aciquicompartirlink/${this.dispositivo.id}/${decoded.token}`;
  
        /*this.linkGenerado =
          protocolo +"://"+ hostSinPuerto + ":" process.env.VUE_APP_PUERTO +
          "/compartirlink/" +
          this.dispositivo.id +
          "/" +
          decoded.token*/
        document.getElementById("linkGenerado").value = this.linkGenerado;
        this.seGeneroLink = true;
      });
    },
    habilitarCopiar() {
      return !this.seGeneroLink;
    },
    habilitarCadudar() {
      return !this.dispositivo.compartirLink;
    },
    caducarToken() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      var datos = {
        username: this.dispositivo.nombre,
        password: this.dispositivo.id,
      };
      token
        .caducar(datos)
        .then(() => {
          //si se logra caducar el token anterior, se actualiza el dispositivo para que deje de compartir link
          var data = {
            nombre: this.dispositivo.nombre,
            contrasena: this.dispositivo.contrasena,
            modelo: this.dispositivo.modelo,
            telefono: this.dispositivo.telefono,
            imei: this.dispositivo.imei,
            compartirLink: false,
            compartirHasta: 0,
            servidor: localStorage.getItem("servidor"),
          };
          DevicesDataService.update(data, this.key).then(
            (this.dispositivo.compartirLink = false)
          );

          Toast.fire({
            icon: "success",
            title: this.$t("vDispositivos.msgCadLink"),
          });
        })
        .catch((e) => {
          var res = e;
          Toast.fire({
            icon: "error",
            title: res,
          });
        });
    },
    async obtenerAreas() {
      AreaDataService.getHabilitados().then(async (response) => {
        this.areas = await Crypto.desencriptar(response.data, this.key);
        if (sessionStorage.idRol == process.env.VUE_APP_ID_MASTER) {
          this.master = true;
        }
      });
    },
    validaciones() {
      return !this.tiempoState;
    },
    tiempoSelected() {
      //dependiendo de la medida de tiempo seleccionada, se valida el valor maximo que se puede ingresar para compartir link
      this.$emit("input", (this.filtro = this.selected));
      switch (this.filtro) {
        case "d":
          this.maximo = 15;
          this.unidad = "días";
          break;
        case "h":
          this.maximo = 23;
          this.unidad = "horas";
          break;
        case "m":
          this.maximo = 59;
          this.unidad = "minutos";
          break;
      }
    },
    onCopy: function (e) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: this.$t("vDispositivos.msgPorta"),
      });
    },
    onError: function (e) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: this.$t("vDispositivos.msgErrPorta"),
      });
    },
    registrarAccion() {
      var data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.myMargin {
  margin-left: 1rem;
}

.submit-form {
  max-width: 400px;
}

.multiselect__tag {
  background: #0e7db9;
}

@media (max-width: 600px) {
  .card {
    margin-top: 10px !important;
  }
}

@media (max-width: 768px) {
  .btnVolver {
    position: absolute;
    top: -40px;
    left: 16px;
  }
}

@media (min-width: 769px) {
  .btnVolver {
    display: none !important;
  }
}

@media (max-width: 959px) {
  .div-display-block {
    display: block;
  }

  .div-separacion {
    margin-top: -14px;
  }
}

@media (min-width: 960px) {
  .div-display-block {
    display: flex;
  }
}

@media (min-width: 992px) {
  .ancho-boton {
    width: 200px;
  }
}

@media (min-width: 1200px) {
  .ancho-boton {
    width: 300px !important;
  }
}

@media (max-width: 991.98px) and (max-height: 950px) {
  .myMargin {
    margin-left: 0px;
  }
}
</style>
